import { createContext } from 'react';
import {
	TFileId,
	TDishType,
	IItemForGetShortInfo,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
	IUpdateModifierV2,
} from 'types';

export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'defaultTranslationIsEmpty';

export interface IEditModifierState {
	needRefetchData: boolean;
	isLoading: boolean;
	filePath: Nullable<string>;
	fileId: TFileId;
	modifierID: string;
	type: TDishType;
	isCreatedOnPos: boolean;
	nameOfModifier: string;
	description: string;
	fetchedCustomers: IItemForGetShortInfo[];
	initialIDSelectedCustomer: Nullable<string>;
	IDSelectedCustomer: Nullable<string>;
	posName: string;
	externalId: string;
	articleNumber: string;
	defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	selectedTranslationTab: Nullable<TLanguageIDs>;
	translations: IMenuTranslation[];
	hasSchedulePriority: boolean;
	activationSchedule: string;
	deactivationSchedule: string;
	fetchedRestaurants: IItemForGetShortInfo[];
	initialIDsSelectedRestaurant: string[];
	IDsSelectedRestaurant: string[];
	dataForSubmit: Nullable<IUpdateModifierV2>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const editModifierInitialState: IEditModifierState = {
	needRefetchData: false,
	isLoading: true,
	filePath: null,
	fileId: null,
	modifierID: '',
	type: null,
	isCreatedOnPos: false,
	nameOfModifier: '',
	description: '',
	fetchedCustomers: [],
	initialIDSelectedCustomer: null,
	IDSelectedCustomer: null,
	posName: '',
	externalId: '',
	articleNumber: '',
	defaultCustomerLanguage: null,
	selectedTranslationTab: null,
	translations: [],
	hasSchedulePriority: false,
	activationSchedule: '',
	deactivationSchedule: '',
	fetchedRestaurants: [],
	initialIDsSelectedRestaurant: [],
	IDsSelectedRestaurant: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IEditModifierContext extends IEditModifierState {
	refetchData(value: boolean): void;
	changeLoaderStatus(value: boolean): void;
	setFileId(value: TFileId): void;
	deletePhoto(): void;
	changeNameOfModifier(value: string): void;
	changeDescription(value: string): void;
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setIDCustomer(value: Nullable<string>): void;
	changeExternalId(value: string): void;
	generateUniqueExternalId(): void;
	setDefaultCustomerLanguage(value: Nullable<IDefaultLanguage>): void;
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	changeDescriptionTranslation(languageId: TLanguageIDs, value: string): void;
	toggleHasSchedulePriority(): void;
	changeActivationSchedule(value: string): void;
	changeDeactivationSchedule(value: string): void;
	setFetchedRestaurants(value: IItemForGetShortInfo[]): void;
	setIDsRestaurant({ value, isInitialSet }: { value: string[]; isInitialSet: boolean }): void;
	setDataForSubmit(data: IUpdateModifierV2): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const EditModifierContext = createContext<IEditModifierContext>({
	refetchData: () => undefined,
	changeLoaderStatus: () => undefined,
	setFileId: () => undefined,
	deletePhoto: () => undefined,
	changeNameOfModifier: () => undefined,
	changeDescription: () => undefined,
	setFetchedCustomers: () => undefined,
	setIDCustomer: () => undefined,
	changeExternalId: () => undefined,
	generateUniqueExternalId: () => undefined,
	setDefaultCustomerLanguage: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	changeDescriptionTranslation: () => undefined,
	toggleHasSchedulePriority: () => undefined,
	changeActivationSchedule: () => undefined,
	changeDeactivationSchedule: () => undefined,
	setFetchedRestaurants: () => undefined,
	setIDsRestaurant: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...editModifierInitialState,
});
